// src/services/historyService.ts
// Service for fetching historical music selections

import apiClient from '../utils/apiClient';

export interface HistorySelection {
  serviceSelectionId: number;
  songId: number;
  versionId: number | null;
  songPlacement: string;
  performanceType: string;
  orderNumber: number;
  songTitle: string;
  composerName: string | null;
  versionTitle?: string;
}

export interface HistoryYear {
  liturgicalYear: string;
  yearLetter: string;
  liturgyDate: string | null;
  isCurrent: boolean;
  songSelections: HistorySelection[];
  serviceMusic: HistorySelection[];
}

export interface SeasonSelectionBySlot {
  songTitle: string;
  composerName: string | null;
  performanceType: string;
  count: number;
  years: string[];
  isCurrent: boolean;
}

export interface SeasonHistory {
  bySlot: Record<string, SeasonSelectionBySlot[]>;
}

export interface ServiceHistoryResponse {
  liturgyName: string;
  season: string | null;
  years: HistoryYear[];
  seasonHistory: SeasonHistory | null;
}

/**
 * Fetch historical music selections for a given liturgy name
 */
export const fetchServiceHistory = async (
  liturgyName: string,
  churchId?: number,
  includeSeason: boolean = true
): Promise<ServiceHistoryResponse> => {
  try {
    const params: Record<string, string> = {
      liturgyName,
      includeSeason: includeSeason.toString()
    };

    if (churchId) {
      params.churchId = churchId.toString();
    }

    const response = await apiClient.get<ServiceHistoryResponse>('/planning/history', {
      params
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching service history:', error);
    throw error;
  }
};
